import { useMemo } from 'react';
import { GameEntity, PlatformType } from '@okletsplay/core';

export const useIsPassphraseAvailable = (game?: GameEntity) => {
  return useMemo(() => game?.platformType === PlatformType.LeagueOfLegends, [game]);
};
